<template>
  <div class="enter-code">
    <div class="enter-code__wrap">
      <div class="p-5 card enter-code__card has-text-centered">
        <IconVerify class="mx-auto fill-primary enter-code__icon"></IconVerify>

        <p class="text-2xl font-semibold">กรอกรหัสสินค้า</p>
        <p class="my-2 text-gray-500">
          กรอกรหัสที่อยู่บนสินค้า แล้วกดยืนยันเพื่อดูข้อมูลสินค้า
        </p>

        <b-field>
          <b-input
            v-model="code"
            placeholder="เช่น X14FU134L941"
            rounded
            size="is-medium"
            custom-class="has-text-centered has-text-weight-semibold"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"
            @input="isFake = false"
            @keyup.native.enter="submitCode"
          ></b-input>
        </b-field>

        <p v-if="isFake" class="mt-2 has-text-danger has-text-weight-semibold">
          <b-icon icon="alert-circle" size="is-small"></b-icon>
          รหัสนี้เป็นของปลอม
        </p>

        <b-button
          type="is-primary is-rounded"
          size="is-medium"
          expanded
          class="mt-5"
          :disabled="!canSubmit"
          :loading="isLoading"
          @click="submitCode"
          >ยืนยัน</b-button
        >
      </div>

      <p class="mt-3 text-gray-400 is-size-7 has-text-centered">
        รหัสอยู่บนฉลาก / บรรจุภัณฑ์ของสินค้า
      </p>
    </div>
  </div>
</template>

<script>
import IconVerify from "./IconVerify.vue";

export default {
  components: {
    IconVerify,
  },
  data() {
    return {
      isLoading: false,
      code: "",
      isFake: false,
    };
  },
  computed: {
    normalizedCode() {
      return this.code.trim();
    },
    canSubmit() {
      return this.normalizedCode.length > 0 && !this.isLoading;
    },
  },
  mounted() {
    // Entry page loads before any company, so --color-primary is unset and
    // buefy is-primary / fill-primary would render blank. Seed a default.
    const root = document.documentElement;
    if (!root.style.getPropertyValue("--color-primary")) {
      root.style.setProperty("--color-primary", "#1f6feb");
    }
  },
  methods: {
    async submitCode() {
      if (!this.canSubmit) return;

      this.isLoading = true;
      this.isFake = false;

      try {
        const code = this.normalizedCode;
        const { statusCode } = await this.$axios.get(`/qrCode/${code}/exists`);

        if (statusCode === 200) {
          this.$router.push(`/${code}`);
        } else {
          this.isFake = true;
        }
      } catch (error) {
        console.error(error);
        this.isFake = true;
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.enter-code {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: calc(env(safe-area-inset-top) + 1.25rem) 1rem
    calc(env(safe-area-inset-bottom) + 1.25rem);

  &__wrap {
    width: 100%;
    max-width: 26rem;
  }

  &__card {
    border-radius: 1.5rem;
  }

  &__icon {
    width: 140px;
    height: auto;
    margin-bottom: 0.5rem;
  }
}
</style>
